import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import CaseStudies from './components/CaseStudies';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import LanguageSwitcher from './components/LanguageSwitcher';
import './App.css';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-dark-900 flex items-center justify-center">
        <div className="relative">
          <div className="w-20 h-20 border-4 border-secondary-500 border-t-transparent rounded-full animate-spin"></div>
          <div className="absolute inset-0 w-20 h-20 border-4 border-primary-500 border-b-transparent rounded-full animate-spin animation-delay-200"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="App min-h-screen bg-dark-900 text-white">
      {/* Language Switcher - Fixed Position */}
      <LanguageSwitcher />
      
      {/* Main Content */}
      <Header />
      <main>
        <Hero />
        <Services />
        <CaseStudies />
        <About />
        <Contact />
      </main>
      <Footer />
      
      {/* Background Effects */}
      <div className="fixed inset-0 pointer-events-none z-0">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-secondary-500/10 rounded-full blur-3xl animate-float"></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-primary-500/10 rounded-full blur-3xl animate-float animation-delay-400"></div>
      </div>
    </div>
  );
}

export default App;